import {
  fetchIntegratorSettings,
  fetchIntegratorSettingsById,
  edit,
  fetchClientsRoteirizations,
  fetchCustomDeliveryDetails,
  saveCustomDeliveryDetails,
  fetchIntegratorInstallInstructions,
  fetchIntegratorInstallInstructionsById,
  editIntegratorInstallInstructions,
  addIntegratorInstallInstructions,
} from "@/api/integrator";

const state = {
  isLoading: false,
  settings: {},
  settingsById: {},
  clientsRoteirizations: [],
  customDeliveryDetails: [],
  installInstructions: [],
  installInstructionsById: {},
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async fetchIntegratorSettings({ dispatch, commit }, payload) {
    try {
      const integratorSettings = await fetchIntegratorSettings(payload);

      commit("setSettings", integratorSettings);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchIntegratorSettingsById({ dispatch, commit }, id) {
    try {
      dispatch("overlay/show", true, { root: true });

      const integratorSettings = await fetchIntegratorSettingsById(id);

      commit("setIntegratorSettingsById", integratorSettings);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    } finally {
      dispatch("overlay/show", false, { root: true });
    }
  },

  async edit({ dispatch }, { id, data }) {
    try {
      dispatch("overlay/show", true, { root: true });

      await edit(id, data);

      return true;
    } catch (e) {
      dispatch("notify/error", e, { root: true });

      return false;
    } finally {
      dispatch("overlay/show", false, { root: true });
    }
  },

  async fetchClientsRoteirizations({ dispatch, commit }, payload) {
    try {
      commit("setLoading", true);

      const clientsRoteirizations = await fetchClientsRoteirizations(payload);

      commit("setClientsRoteirizations", clientsRoteirizations);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    } finally {
      commit("setLoading", false);
    }
  },

  async fetchCustomDeliveryDetails({ dispatch, commit }, companyId) {
    try {
      dispatch("overlay/show", true, { root: true });

      const { customDeliveryDetails } = await fetchCustomDeliveryDetails(
        companyId
      );

      commit("setCustomDeliveryDetails", customDeliveryDetails || []);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    } finally {
      dispatch("overlay/show", false, { root: true });
    }
  },

  async saveCustomDeliveryDetails({ dispatch, commit }, payload) {
    try {
      commit("setLoading", true);

      await saveCustomDeliveryDetails(payload);

      return true;
    } catch (e) {
      dispatch("notify/error", e, { root: true });

      return false;
    } finally {
      commit("setLoading", false);
    }
  },

  async fetchIntegratorInstallInstructions({ dispatch, commit }, payload) {
    try {
      const integratorInstallInstructions =
        await fetchIntegratorInstallInstructions(payload);

      commit("setInstallInstructions", integratorInstallInstructions);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchIntegratorInstallInstructionsById({ dispatch, commit }, id) {
    try {
      dispatch("overlay/show", true, { root: true });

      const integratorInstallInstructions =
        await fetchIntegratorInstallInstructionsById(id);

      commit(
        "setIntegratorInstallInstructionsById",
        integratorInstallInstructions
      );
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    } finally {
      dispatch("overlay/show", false, { root: true });
    }
  },

  async editIntegratorInstallInstructions({ dispatch }, { id, data }) {
    try {
      dispatch("overlay/show", true, { root: true });

      await editIntegratorInstallInstructions(id, data);

      return true;
    } catch (e) {
      dispatch("notify/error", e, { root: true });

      return false;
    } finally {
      dispatch("overlay/show", false, { root: true });
    }
  },

  async addIntegratorInstallInstructions({ dispatch }, data) {
    try {
      dispatch("overlay/show", true, { root: true });

      await addIntegratorInstallInstructions(data);

      return true;
    } catch (e) {
      dispatch("notify/error", e, { root: true });

      return false;
    } finally {
      dispatch("overlay/show", false, { root: true });
    }
  },
};

const mutations = {
  cleanState(state) {
    state.isLoading = false;
    state.settings = {};
    state.settingsById = {};
    state.clientsRoteirizations = [];
    state.customDeliveryDetails = [];
    state.installInstructions = [];
    state.installInstructionsById = {};
  },

  setSettings(state, settings) {
    state.settings = settings;
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },

  setIntegratorSettingsById(state, integratorSettings) {
    state.settingsById = integratorSettings;
  },

  setClientsRoteirizations(state, clientsRoteirizations) {
    state.clientsRoteirizations = clientsRoteirizations;
  },

  setCustomDeliveryDetails(state, customDeliveryDetails) {
    state.customDeliveryDetails = customDeliveryDetails;
  },

  setIntegratorInstallInstructions(state, integratorInstallInstructions) {
    state.installInstructions = integratorInstallInstructions;
  },

  setIntegratorInstallInstructionsById(state, integratorInstallInstructions) {
    state.installInstructionsById = integratorInstallInstructions;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
